import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IUser } from 'src/app/core/models/user.model';

@Component({
  selector: 'app-general-settings-checkbox',
  templateUrl: './general-settings-checkbox.component.html',
  styleUrls: ['./general-settings-checkbox.component.css']
})
export class GeneralSettingsCheckboxComponent implements OnInit {

  @Input() user: IUser;;
  @Input() defaultChecked: string;
  @Input() disabled: string;
  @Input() checkType2: boolean;
  @Input() userCheck: boolean;
  @Input() data: any;
  @Output() select = new EventEmitter<Object>();
  @Output() notifyF = new EventEmitter<Object>();

  constructor() { }

  ngOnInit(): void {
  }

  patchType(event) {
    this.select.emit(event);
  }

  patchType2(event, data) {
    this.select.emit({ event, data });
  }
  checkItem(event) {
    this.select.emit(event);
  }
  notify() {
    this.notifyF.emit();
  }

}
